export default function reducer(state={
    auth: false,
    userData: null
}, action){

    switch (action.type) {
        case "LOGIN_STATE_CHANGED":
            return {...state, auth: action.payload.auth, userData: action.payload.data}
        case "USER_LOGIN":
            return {...state, loginProgress: true, loginError: null}
        case "USER_LOGIN_REJECTED":
            return {...state, loginProgress:false, loginError: action.payload}
        case "USER_LOGIN_FULFILLED":
            return {
                ...state,
                loginProgress: false,
                loginSuccess: true
            }
        case "USER_SIGNUP":
            return {...state, signupProgress: true, signupError: null}
        case "USER_SIGNUP_REJECTED":
            return {...state, signupProgress:false, signupError: action.payload}
        case "USER_SIGNUP_FULFILLED":
            return {
                ...state,
                signupProgress: false,
                signupSuccess: true
            }
        case "USER_RECOVER":
            return {...state, recoverProgress: true, recoverError: null}
        case "USER_RECOVER_REJECTED":
            return {...state, recoverProgress:false, recoverError: action.payload}
        case "USER_RECOVER_FULFILLED":
            return {
                ...state,
                recoverProgress: false,
                recoverSuccess: true
            }
        case "USER_HACKATON":
            return {...state, hackatonProgress: true, hackatonError: null}
        case "USER_HACKATON_REJECTED":
            return {...state, hackatonProgress:false, hackatonError: action.payload}
        case "USER_HACKATON_FULFILLED":
            return {
                ...state,
                hackatonProgress: false,
                hackatonSuccess: true
            }
        case "USER_INFOQ":
            return {...state, infoQProgress: true, infoQError: null}
        case "USER_INFOQ_REJECTED":
            return {...state, infoQProgress:false, infoQError: action.payload}
        case "USER_INFOQ_FULFILLED":
            return {
                ...state,
                infoQProgress: false,
                infoQSuccess: true
            }
        case "USER_INVITE":
            return {...state, inviteProgress: true, inviteError: null}
        case "USER_INVITE_FULFILLED":
            return {...state, inviteProgress: false, inviteSuccess: true}
        case "USER_INVITE_REJECTED":
            return {...state, inviteProgress: false, inviteError: action.payload}
        case "USER_LOGOUT_FULFILLED":
            return {}          
        case "PAYWITHTWEET_COMPLETED":
            return {...state, payWithTweetCompleted: true}                          
        default:   
        return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/user.js